import { useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../components/input/Input";
import { toast } from "react-toastify";
import Panel from "../../../components/panel/panel";
import { Button } from "primereact/button";
import { postIbJuridico } from "../../../services/Settings/IbJuridico/postIbJuridico";
import { patchIbJuridico } from "../../../services/Settings/IbJuridico/patchIbJuridico";





const RegisterIbJuridico = ({ refetch, setSelected, patch }) => {

  const [loading, setLoading] = useState(false);
  const form = useForm();

  const onSubmit = async (data) => {
    let response;
    let obj = {
      "token": data.token,
      "type": "token"
    }
    let obj_patch = {
      "token": data.token,
      "status": true
    }
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      if (patch === 1) {
        response = await patchIbJuridico(obj_patch);
      } else {
        response = await postIbJuridico(obj);
      }


      toast.update(notification, {
        render: "Escritório Cadastrado com sucesso!",
        autoClose: 5000,
        type: "success",  
        isLoading: false,
      });

    } catch (e) {


      toast.update(notification, {
        render: "Token Ib Jurídico inválido.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
    setSelected(0)
    refetch();
    setLoading(false);

  }



  return (
    <>
      <Panel>
        <form onSubmit={form.handleSubmit(onSubmit)} className="fs-13px">
          <div className="mb-3">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-landmark"></i>Integração Ib Juridico
            </label>
            <hr />
            <div className="row gx-3">
              <div className="col-md-12">
                <Input
                  isRequired
                  type="text"
                  control={form.control}
                  errors={form.formState.errors}
                  label="Token de Integração"
                  name="token"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="text-end">
            <Button
              label="Cadastrar"
              type="submit"
              loading={loading}
            >

            </Button>
          </div>
        </form>
      </Panel>


    </>
  );
};

export default RegisterIbJuridico;
